import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { categoryPillGroupSx, categoryPillSx } from './categoryPillStyles';

const CategoryPills = ({
  id,
  name = 'category',
  label = 'Category*',
  value,
  option = [],
  onChange,
  readOnly = false,
  centered = false,
}) => {
  const visibleOptions = readOnly && value
    ? option.filter((item) => item.value === value)
    : option;

  const handleSelect = (nextValue) => {
    if (readOnly) return;
    onChange({ target: { name, value: nextValue } });
  };

  return (
    <Box id={id} sx={{ mt: 2 }}>
      <Typography
        component="label"
        htmlFor={`${name}-pills`}
        sx={{ color: '#fff', fontSize: 14, mb: 1, display: 'block', textAlign: centered ? 'center' : 'left' }}
      >
        {label}
      </Typography>
      <input type="hidden" name={name} value={value || ''} />
      <Box
        id={`${name}-pills`}
        role="listbox"
        aria-label={label}
        sx={{ ...categoryPillGroupSx, justifyContent: centered ? 'center' : 'flex-start' }}
      >
        {visibleOptions.map(({ value: optionValue, label: optionLabel }) => {
          const selected = value === optionValue;
          return (
            <Box
              key={optionValue}
              component="button"
              type="button"
              role="option"
              aria-selected={selected}
              disabled={readOnly}
              onClick={() => handleSelect(optionValue)}
              sx={categoryPillSx(selected, { readOnly })}
            >
              {optionLabel}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default CategoryPills;
